import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import CollectionCard from "./CollectionCard";
import type { TransformedWPCategory } from "../../../types/productTaxonomyApiTypes";
import "swiper/css";
import "swiper/css/pagination";

interface CollectionsSliderProps {
  categories: TransformedWPCategory[];
  activeCategoryId: number | null;
  onCategoryClick: (categoryId: number) => void;
  isLoading: boolean;
}

const CollectionsSlider: React.FC<CollectionsSliderProps> = ({
  categories,
  activeCategoryId,
  onCategoryClick,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="collections-slider collections-slider--loading">
        {Array.from({ length: 4 }).map((_, index) => (
          <CollectionCard.Skeleton key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="collections-slider">
      <Swiper
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerView={2}
        pagination={{ clickable: true, el: ".collections-slider__pagination" }}
        breakpoints={{
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
        className="collections-swiper"
      >
        {categories.map((category) => (
          <SwiperSlide key={category.id}>
            <CollectionCard
              title={category.name}
              imageUrl={category.thumbnail?.url || null}
              imageAlt={category.thumbnail?.alt || category.name}
              isActive={category.id === activeCategoryId}
              onClick={() => onCategoryClick(category.id)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="collections-slider__pagination swiper-pagination"></div>
    </div>
  );
};

export default CollectionsSlider;
